import { render } from "./FlaskBlock.vue?vue&type=template&id=2e7a1a20&scoped=true"
import script from "./FlaskBlock.vue?vue&type=script&lang=js"
export * from "./FlaskBlock.vue?vue&type=script&lang=js"

import "./FlaskBlock.vue?vue&type=style&index=0&id=2e7a1a20&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./FlaskBlock.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7a1a20"]])

export default __exports__